export default __webpack_public_path__ + "static/media/rumble-doll.4c46969c.webp";